import React, {useEffect, useState} from 'react'
import { Button, Card, Checkbox, Col, DatePicker, Divider, Form, Input, Row } from 'antd'
import {Table} from 'antd'
import moment from 'moment'
import ISelectForNormal from '../../../../../components/common/i-select-for-normal'
import swal from '../../../../../services/lib/utils/sweet-alert-service'
import CommonMachineCard from '../../../../../components/common/others/common-machine-card'
import {
  deleteArrangementRequest,
  getDateRequest,
  getEmployeeRequest,
  getMachineRequest, getWeekRequest,
  postArrangementRequest, updateArrangementRequest
} from '../../../../../services/others/work-arrangement-services'
import { commonFormSelect, getSelectOptions } from '../../../../../components/common/common-form/common-form-select'
import { urlKey } from '../../../../../services/api/api-urls'
import { ButtonsForPageLink } from './work-arrangement-presentation-only-page'
import { useDocumentTitle } from '../../../../../services/title/useDocumentTitle'
import { CheckCircleOutlined, CheckOutlined, CloseCircleOutlined, CloseOutlined } from '@ant-design/icons'

interface machine2{
  machineId: number,
  machineName: string,
  machineTypeId: number,
  picture: string
}
const WorkArrangement: any = (props: {isPresentOnly: boolean}) => {

  const [Date, setDate] = useState<any>(moment())
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [userSelect, setUserSelect] = useState<any>([])
  const [allMachines, setAllMachines] = useState<any>([])
  const [arrangeData, setArrangeData] = useState<any>([])
  const [newUser, setNewUser] = useState<any>([])
  const [selectedDate, setSelectedDate] = useState<string>(moment().format('YYYY-MM-DD'))
  const [selectedStr, setSelectedStr] = useState<any>()
  const [employeeOptions, setEmployeeOptions] = useState([])

  // useEffect(() => {
  //   document.title = props.isPresentOnly ? 'Weekly Schedule' : 'Work Arrangement';
  //  }, [])
  useDocumentTitle();

  useEffect(() => {
    getSelectOptions(urlKey.Employee).then(res => setEmployeeOptions(res.map((row: any) => ({...row, name: row.firstName + ' ' + row.lastName}))))
    getEmployeeRequest()
      .then((res) => {
        // console.log(res.data.data, 'getDataFromApi')
        const users = dataTransfer(res.data.data, 'users')
        setUserSelect(users)
      }
      )
    getMachineRequest()
      .then((res) => {
        // console.log(res.data.data,'machine')
        const machines = dataTransfer(res.data.data, 'machines')
        setAllMachines(machines)
        getArrangementData(selectedDate, machines)
      })
  }, [])

  const weekday = (day: any, selectedDay?:string,) => {
    return moment(selectedDay).isoWeekday(day).format('YYYY-MM-DD')
  }

  //maintenance
  const getArrangementData = (date:any, machines:any) => {
    // console.log(date,'1111')
    getWeekRequest(weekday(1, date), weekday(7, date))
      .then((res:any) => {
        // console.log(res.data.data,'week')
        const tableData = mergeTest(machines, res.data.data, date)
        // console.log(tableData,'tableDataInWeek')
        setArrangeData(tableData)
      })
  }

  const mergeTest = (machines: any, allMachinesOperateTime: any, selectedDay: string) => {
    const newArray: any = [];
  
    // 如果 allMachinesOperateTime 为空，初始化一个空的周计划
    if (allMachinesOperateTime.length === 0) {
      machines.forEach((res: any) => {
        newArray.push({
          machine: res,
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null,
        });
      });
      return newArray;
    }
  
    // 遍历每台机器
    machines.forEach((res: any) => {
      const obj: any = {
        machine: res,
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
      };
  
      // 遍历所有机器的操作时间
      for (let i = 0; i < allMachinesOperateTime.length; i++) {
        if (res.id === allMachinesOperateTime[i].machine.machineId) {
          // 获取当前操作时间的日期
          const workingDate = allMachinesOperateTime[i].workingDate.slice(0, 10);
  
          // 遍历一周的每一天
          for (let day = 1; day <= 7; day++) {
            const dayKey = moment().isoWeekday(day).format('dddd').toLowerCase(); // 获取星期几的键（如 "monday"）
            if (workingDate === weekday(day, selectedDay)) {
              obj[dayKey] = {
                user: {
                  id: allMachinesOperateTime[i].operatorNavigation?.employeeId,
                  name: allMachinesOperateTime[i].operatorNavigation?.firstName + ' ' + allMachinesOperateTime[i].operatorNavigation?.lastName,
                },
                arrangeId: allMachinesOperateTime[i].arrangementId,
                maintenance: allMachinesOperateTime[i].maintenance,
              };
            }
          }
        }
      }
  
      newArray.push(obj);
    });
  
    return newArray;
  };
  //改变datepicker的function
  const selectHandler = (data:any, dateString:string) => {
    setSelectedDate(dateString)
    getArrangementData(dateString, allMachines)
  }

  const dataTransfer = (data:any, filter: string) => {
    const newArray:any = []
    if (filter === 'machines') {
      data.map((res:machine2) => {
        newArray.push({
          id: res.machineId,
          img: res.picture,
          name: res.machineName,
          type_id: res.machineTypeId
        }
        )
      })
    }

    if (filter === 'users') {
      data.map((res:any) => {
        newArray.push({
          id: res.employeeId,
          name: res.firstName + ' ' + res.lastName
        })
      })
    }
    // console.log(newArray)
    return newArray
  }

  const onchange = (data: any, rowData:any, days:any, selectedDay:any) => {
    console.log(rowData, days, rowData[days], 'onchange rowData')
    const finalData:any = {
      machine: rowData.machine,
      user: { id: data.value, name: data.children},
      selectedDay: selectedDay,
      day: days,
      maintenance: rowData[days]?.maintenance
    }
    console.log(finalData, 'in select user')

    if (rowData[days]?.arrangeId) {
      // console.log('good',rowData[days])
      finalData.arrangeId = rowData[days].arrangeId
    }
    // console.log(finalData,'in select user')

    // console.log(rowData[days],'这一天有没有arrange')
    // console.log(days,'days')
    // console.log(data, rowData,'select 得到的数据')
    // console.log(rowData, merge, 'select 得到的数据2')
    // console.log(finalData, 'complete')
    const copyNewUser = [...newUser]
    // console.log(newUser,'newUser')

    const indexOfSelector = copyNewUser.findIndex((element:any) => element.machine.id === finalData.machine.id && element.selectedDay === finalData.selectedDay)
    if (indexOfSelector !== -1) {
      // console.log(copyNewUser[c].user,finalData,'copyNewUser[c]')
      copyNewUser[indexOfSelector].user.id = finalData.user.id
      copyNewUser[indexOfSelector].user.name = finalData.user.name
      setNewUser(copyNewUser)
    } else {
      setNewUser((prevState:any) => [...prevState, finalData])
    }

  }

  const checkBoxOnChange = (checked:boolean, rowData:any, days:any, selectedDate:any, isChecked:any) => {
    // console.log(checked,rowData,days,selectedDate,isChecked,'传上来了')
    const finalData:any = {
      machine: rowData.machine,
      user: {id: rowData[days]?.user?.id, name: rowData[days]?.user?.name},
      selectedDay: selectedDate,
      day: days,
      maintenance: checked === true ? 0 : 1
    }

    if (rowData[days]?.arrangeId) {
      // console.log('good',rowData[days])
      finalData.arrangeId = rowData[days].arrangeId
    }

    // console.log(rowData[days],'rowData[days]')
    const copyNewUser = [...newUser]
    // console.log(copyNewUser,'copyUser in checkbox')
    const indexOfCheck = copyNewUser.findIndex((element:any) => element.machine.id === finalData.machine.id && element.selectedDay === finalData.selectedDay)
    // console.log(indexOfCheck,'判断copyUser里面是否有一样的')
    if (indexOfCheck === -1) {
      // console.log(finalData, 'in -1')
      setNewUser((prevState:any) => [...prevState, finalData])
    } else {
      copyNewUser[indexOfCheck].maintenance = finalData.maintenance
      setNewUser(copyNewUser)
    }
    console.log(newUser, finalData, 'newUser')

  }

  const getWeekTextRender = (data: any) => {
    return (
      <>
        {data?.user?.id ? (
          <span style={{background: selectedStr && data?.user?.name?.toLowerCase().includes(selectedStr.toLowerCase()) ? 'yellow' : 'none'}}>
            {data?.user?.name}
          </span>
        ) : ''}
        {data?.maintenance === 0 ? (
          <span style={{color: 'green'}}>
            <CheckOutlined style={{fontSize: '1.5rem'}} />
          </span>
        ) : (
          <span style={{color: 'red'}}>
            <CloseOutlined style={{fontSize: '1.5rem'}} />
          </span>
        )}
      </>
    )
  }

  const generateDayColumn = (day: number, selectedDate: string) => {
    const dayKey = moment().isoWeekday(day).format('dddd').toLowerCase(); // 获取星期几的键（如 "monday"）
    const dayTitle = `${moment().isoWeekday(day).format('dddd')} (${weekday(day, selectedDate).slice(5)})`; // 列标题
  
    return {
      title: dayTitle,
      key: dayKey,
      render: (text: any, record: any) => {
        return (
          <>
            {isEdit ? (
              <ICheckBox
                checkBoxChange={checkBoxOnChange}
                location={text}
                title={dayKey}
                date={weekday(day, selectedDate)}
                isChecked={text[dayKey]?.maintenance === 0 ? 1 : 0}
              />
            ) : (
              getWeekTextRender(text[dayKey])
            )}
          </>
        );
      },
    };
  };
  
  const columns = [
    {
      title: 'Name',
      dataIndex: ['machine', 'name'],
      key: 'name',
      width: 200,
    },
    ...Array.from({ length: 7 }, (_, i) => generateDayColumn(i + 1, selectedDate)), // 动态生成周一到周日的列
  ];
  const submitHandler2 = async () => {
    const postData:any = []
    const updateData:any = []
    const deleteData:number[] = []
    const updateToTable = [...arrangeData]
    // console.log(updateToTable,'updateToTable')
    // console.log(newUser,'in submit')
    newUser.forEach((res:any) => {
      // console.log(res,'newU ForEach')

      //modifyData找到得是newUser里每个所对应的在column里的index
      const modifyData = updateToTable.findIndex((res1:any) => res1.machine === res.machine)
      console.log(updateToTable[modifyData], 'updateToTable[modifyData]')
      // updateToTable[modifyData] = res

      // console.log(updateToTable[modifyData][res.day],res.day)
      if (updateToTable[modifyData][res.day] === null) {
        console.log(res, 'post')
        const obj = {
          machineId: res.machine.id,
          operator: res.user?.id,
          workingDate: res.selectedDay,
          maintenance: res.maintenance
        }
        console.log(obj, 'postObj')
        postData.push(obj)
      } else {
        if (res.user.id === null) {
          console.log(res, 'delete')
          deleteData.push(res.arrangeId)
        } else {
          console.log(res, 'put')
          const obj = {
            machineId: res.machine.id,
            operator: res.user.id,
            workingDate: res.selectedDay,
            arrangementId: res.arrangeId,
            maintenance: res.maintenance
          }
          console.log(obj, 'putObj')
          updateData.push(obj)
        }

      }
    })

    const result = await swal.confirmMessage()
    if (result) {
      if (postData.length !== 0) {
        // console.log(postData,'post')
        postArrangementRequest(postData).then(res => console.log(res, 'post成功')).then(_ => getArrangementData(selectedDate, allMachines))
      }
      if (updateData.length !== 0) {
        // console.log(updateData,'put')
        updateArrangementRequest(updateData).then(res => console.log(res, 'put成功')).then(_ => getArrangementData(selectedDate, allMachines))
      }
      if (deleteData.length !== 0) {
        // console.log(deleteData,'delete')
        deleteArrangementRequest(deleteData).then(res => console.log(res, 'delete成功')).then(_ => getArrangementData(selectedDate, allMachines))
      }
      setArrangeData(updateToTable)
    }
    setIsEdit(false)
    setNewUser([])
  }
  return (
    <div>
      <style>{`
        .work-arrangement-table-scope .ant-table-tbody > tr:hover > td {
          background: #d6f5e8 !important;
        }
      `}</style>
      <Row>
        <Col span={24}>
          <h1 style={{margin: 0}}>
            {props.isPresentOnly ? 'Weekly Schedule' : 'Work Arrangement'}
            {/* {props.isPresentOnly ? (
              <div>
                <ButtonsForPageLink />
              </div>
            ) : null} */}
            {/* <div style={{width: '30%'}}>
              {commonFormSelect(urlKey.Employee, employeeOptions, ['firstName', 'lastName'], false, (value: any) => setSelectedStr(value), 'name', 'Find name')}
            </div> */}
          </h1>
          <Row style={{padding: '1rem 0'}}>
            <Col span={8}>
              <DatePicker onChange={selectHandler} defaultValue={moment(Date, 'YYYY-MM-DD')} style={{width: '100%'}} />
            </Col>
          </Row>
          <Row>
            {props.isPresentOnly ? null : (
              <div style={{display: 'flex', justifyContent: 'flex-start', margin: '0 0 1rem 0'}}>
                {!isEdit && <Button type="primary" style={{float: 'right'}} onClick={() => setIsEdit(true)}>Edit</Button>}
                <div style={{float: 'right'}}>
                  {isEdit && <Button type="primary" onClick={submitHandler2}>Submit</Button>}&nbsp;
                  {isEdit && <Button onClick={() => setIsEdit(false)}>Cancel</Button>}
                </div>
              </div>
            )}
            <div className='work-arrangement-table-scope' style={{width: '100%'}}>
              <Table columns={columns} dataSource={arrangeData} pagination={false} scroll={{ x: 'max-content', y: 'calc(100vh - 260px)' }}/>
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

const ICheckBox = (props:{checkBoxChange:(data:any, rowData:any, days:any, selectedDay:any, isChecked:any) => void, location:any, title:any, date:any, isChecked:number}) => {
  const [isChecked, setIsChecked] = useState(props.isChecked === 1)
  // console.log(props.isChecked)
  const onChangeHandler = (e:any) => {
    // console.log(e.target.checked)
    setIsChecked(!isChecked)

    props.checkBoxChange(e.target.checked, props.location, props.title, props.date, props.isChecked)
  }
  return (
    <Checkbox
      style={{ marginLeft: '0.5rem', transform: 'scale(1.2)' }}
      onChange={onChangeHandler}
      checked={isChecked}
    >
      {isChecked ? <CheckCircleOutlined style={{ color: '#1890ff', fontSize: '1.2rem' }} /> : <CloseCircleOutlined style={{ color: '#ff4d4f', fontSize: '1.2rem' }} />}
    </Checkbox>
  )
}

export default WorkArrangement
